import React, { FC } from 'react';
import styled from 'styled-components';
import { useDataTableFilterContext } from '../../utils/DataTableFilterContext';
import { QueryModel } from '../../utils/DataTableQueryProvider/DataTableQuery.types';
import { useDataTableQueryContext } from '../../utils/DataTableQueryProvider/DataTableQueryProvider';
import { DataTableFilterProps, DataTableFilterWrapper } from './DataTableFiltersChip';

type KeyOfQuery<Q> = keyof Q & string;

interface Props {
  filters: DataTableFilterProps<KeyOfQuery<QueryModel>>[];
}

export const DataTableFiltersContent: FC<React.PropsWithChildren<Props>> = ({ filters }) => {
  const { visibleFilters, clearVisibleFilters } = useDataTableFilterContext();
  const { applyQuery } = useDataTableQueryContext();
  const showAllFilters = visibleFilters === 'all';

  return (
    <StyledContent>
      {filters.map((props) => {
        const isHidden = showAllFilters ? false : !visibleFilters.includes(props.id);
        return (
          <DataTableFilterWrapper
            disableDeleteButton={showAllFilters}
            style={props.style}
            key={props.id}
            id={props.id}
            label={props.label}
            value={!!props.value}
            hidden={!showAllFilters ? isHidden : false}
            onClear={() => {
              if (props.onClear) {
                props.onClear();
              } else {
                applyQuery({ [props.id]: undefined }, { persist: true, mode: 'patch' });
              }
              clearVisibleFilters([props.id]);
            }}
          >
            {props.children}
          </DataTableFilterWrapper>
        );
      })}
    </StyledContent>
  );
};

const StyledContent = styled.div`
  padding: ${({ theme }) => theme.spacingSize.xl} 0;
`;
